import { Symbol } from "./Logo";

export const Marquee = ({ items, testid = "marquee" }) => {
  const row = (
    <div className="flex shrink-0 items-center">
      {items.map((t, i) => (
        <span key={i} className="flex items-center">
          <span className={`px-8 font-display text-5xl font-semibold uppercase tracking-tight md:text-7xl lg:text-8xl ${i % 2 ? "text-outline" : "text-cream"}`}>{t}</span>
          <Symbol className="h-8 w-auto text-skaris-sky md:h-12" />
        </span>
      ))}
    </div>
  );
  return (
    <div data-testid={testid} className="relative overflow-hidden border-y border-cream/10 py-10 md:py-14">
      <div className="marquee-track flex w-max">
        {row}
        {row}
      </div>
    </div>
  );
};
